export default __webpack_public_path__ + "static/media/info-new-mail.67d99341.gif";